import React from "react";
import { createUseStyles } from "react-jss";
import { LazyImage } from "react-lazy-images";

const useStyles = createUseStyles((theme) => ({
	root: {
		maxWidth: "120px",
		textAlign: "center",
	},
	img: {
		maxHeight: "50px",
		maxWidth: "100%",
	},
	providerName: {
		padding: "5px 0",
		textAlign: "center",
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		letterSpacing: "2px",
		color: theme.palette.colors.oneMoreGrey,
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			height: "30px",
			minWidth: "60px",
			marginLeft: "auto",
			textAlign: "end",
		},
		img: {
			height: "30px",
		},
		providerName: {
			display: "none",
		},
	},
}));

const ProviderLogo = ({ name, path }) => {
	const classes = useStyles();

	return (
		<>
			<div className={classes.root}>
				<LazyImage
					src={path}
					placeholder={({ ref }) => <img ref={ref} />}
					actual={({ imageProps }) => <img {...imageProps} className={classes.img} alt={name} />}
				/>
			</div>
			<div className={classes.providerName}>{name}</div>
		</>
	);
};

export default ProviderLogo;
